import { ProgressStatus } from '@startuptools/ui/Progress';
import { Trans } from '@lingui/react';
import { GqlAgreementStatus, GqlDecisionStatus, GqlRegistrationStatus } from '../../../../graphql/base-types.graphql';
import React from 'react';

export const agreementStatusToProgress = (status: GqlAgreementStatus): ProgressStatus => {
  switch (status) {
    case GqlAgreementStatus.Failed:
      return ProgressStatus.Error;
    case GqlAgreementStatus.Signed:
      return ProgressStatus.Done;
    case GqlAgreementStatus.NotSent:
    case GqlAgreementStatus.Sent:
      return ProgressStatus.Pending;
  }
};

export const decisionStatusToProgress = (status: GqlDecisionStatus): ProgressStatus => {
  switch (status) {
    case GqlDecisionStatus.Planned:
    case GqlDecisionStatus.Sent:
      return ProgressStatus.Pending;
    case GqlDecisionStatus.Signed:
      return ProgressStatus.Done;
    case GqlDecisionStatus.Failed:
      return ProgressStatus.Error;
  }
};

export const registrationStatusToProgress = (status: GqlRegistrationStatus): ProgressStatus => {
  switch (status) {
    case GqlRegistrationStatus.NotRegistered:
      return ProgressStatus.Pending;
    case GqlRegistrationStatus.NotApplicable:
    case GqlRegistrationStatus.Registered:
      return ProgressStatus.Done;
  }
};

export const AgreementStatusExplanation = ({ status }: { status: GqlAgreementStatus }) => {
  switch (status) {
    case GqlAgreementStatus.Failed:
      return <Trans id="Something went wrong with the documents" />;
    case GqlAgreementStatus.Signed:
      return <Trans id="The documents have been signed by all signatories" />;
    case GqlAgreementStatus.NotSent:
      return <Trans id="The documents have not yet been sent for signatures" />;
    case GqlAgreementStatus.Sent:
      return <Trans id="The documents have not been signed by all signatories" />;
  }
};

export const DecisionStatusExplanation = ({ status }: { status: GqlDecisionStatus }) => {
  switch (status) {
    case GqlDecisionStatus.Planned:
      return <Trans id="The decision is not sent for signatures" />;
    case GqlDecisionStatus.Sent:
      return <Trans id="The decision is not yet fully signed" />;
    case GqlDecisionStatus.Signed:
      return <Trans id="The decision is made and fully signed" />;
    case GqlDecisionStatus.Failed:
      return <Trans id="Something went wrong with the decision" />;
  }
};

export const RegistrationStatusExplanation = ({ status }: { status: GqlRegistrationStatus }) => {
  switch (status) {
    case GqlRegistrationStatus.NotRegistered:
      return <Trans id="Not yet registered" />;
    case GqlRegistrationStatus.NotApplicable:
      return <Trans id="Registration not required" />;
    case GqlRegistrationStatus.Registered:
      return <Trans id="Registration is done" />;
  }
};
